import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import mateSlice from './slices/mateSlice';
import gameSlice from './slices/gameSlice';
import yatzySlice from './slices/yatzySlice';
import uiSlice from './slices/uiSlice';
import { persistenceMiddleware } from './middleware/persistenceMiddleware';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    mate: mateSlice,
    game: gameSlice,
    yatzy: yatzySlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(persistenceMiddleware),
});
